import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "acIcon",
  "use": "acIcon-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"acIcon\"><g data-name=\"Group 11911\" transform=\"translate(-10294 1759)\"><circle data-name=\"Ellipse 532\" cx=\"11\" cy=\"11\" r=\"11\" transform=\"translate(10294 -1759)\" fill=\"#031425\" /><text transform=\"translate(10298 -1744)\" fill=\"#fff\" font-size=\"11\" font-family=\"Roboto-Bold, Roboto\" font-weight=\"700\"><tspan x=\"0\" y=\"0\">AC</tspan></text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol